var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getVenue)?_c('b-form-datepicker',{attrs:{"min":_vm.minDate,"max":_vm.maxDate,"locale":_vm.$i18n.locale,"id":"datePicker"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }